import _definePage_default_0 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/chat.vue?definePage&vue'
import _definePage_default_3 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/email/index.vue?definePage&vue'
import _definePage_default_4 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/logistics/fleet.vue?definePage&vue'
import _definePage_default_5 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/checkout.vue?definePage&vue'
import _definePage_default_6 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/help-center/index.vue?definePage&vue'
import _definePage_default_7 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/help-center/article/[title].vue?definePage&vue'
import _definePage_default_8 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/landing-page/index.vue?definePage&vue'
import _definePage_default_9 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/payment.vue?definePage&vue'
import _definePage_default_10 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/pricing.vue?definePage&vue'
import _definePage_default_11 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/insights-overview/ai/index.vue?definePage&vue'
import _definePage_default_12 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_13 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_14 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_15 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/forgot-password-v1.vue?definePage&vue'
import _definePage_default_16 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/forgot-password-v2.vue?definePage&vue'
import _definePage_default_17 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/login-v1.vue?definePage&vue'
import _definePage_default_18 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/login-v2.vue?definePage&vue'
import _definePage_default_19 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/register-multi-steps.vue?definePage&vue'
import _definePage_default_20 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/register-v1.vue?definePage&vue'
import _definePage_default_21 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/register-v2.vue?definePage&vue'
import _definePage_default_22 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/reset-password-v1.vue?definePage&vue'
import _definePage_default_23 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/reset-password-v2.vue?definePage&vue'
import _definePage_default_24 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/two-steps-v1.vue?definePage&vue'
import _definePage_default_25 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/two-steps-v2.vue?definePage&vue'
import _definePage_default_26 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/verify-email-v1.vue?definePage&vue'
import _definePage_default_27 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/verify-email-v2.vue?definePage&vue'
import _definePage_default_28 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/misc/coming-soon.vue?definePage&vue'
import _definePage_default_29 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/misc/under-maintenance.vue?definePage&vue'
import _definePage_default_30 from '/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/user-profile/[tab].vue?definePage&vue'

export const routes = [
  {
    path: '/_template-page',
    name: 'template-page',
    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/_template-page.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'academy',
        /* internal name: 'apps-academy' */
        /* no component */
        children: [
          {
            path: 'course-details',
            name: 'apps-academy-course-details',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/academy/course-details.vue'),
            /* no children */
          },
          {
            path: 'dashboard',
            name: 'apps-academy-dashboard',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/academy/dashboard.vue'),
            /* no children */
          },
          {
            path: 'my-course',
            name: 'apps-academy-my-course',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/academy/my-course.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'calendar',
        name: 'apps-calendar',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/calendar.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'apps-chat',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/chat.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
      {
        path: 'ecommerce',
        /* internal name: 'apps-ecommerce' */
        /* no component */
        children: [
          {
            path: 'customer',
            /* internal name: 'apps-ecommerce-customer' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-customer-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-customer-details-id',
                    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/customer/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-customer-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-customer-list',
                    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/customer/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'manage-review',
            name: 'apps-ecommerce-manage-review',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/manage-review.vue'),
            /* no children */
          },
          {
            path: 'order',
            /* internal name: 'apps-ecommerce-order' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-order-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-details-id',
                    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/order/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-order-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-list',
                    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/order/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'product',
            /* internal name: 'apps-ecommerce-product' */
            /* no component */
            children: [
              {
                path: 'add',
                /* internal name: 'apps-ecommerce-product-add' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-add',
                    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/product/add/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'category-list',
                name: 'apps-ecommerce-product-category-list',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/product/category-list.vue'),
                /* no children */
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-product-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-list',
                    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/product/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'referrals',
            name: 'apps-ecommerce-referrals',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/referrals.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'apps-ecommerce-settings',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/ecommerce/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email',
        /* internal name: 'apps-email' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-email',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/email/index.vue'),
            /* no children */
          },
  _definePage_default_3
  )
        ],
      },
      {
        path: 'invoice',
        /* internal name: 'apps-invoice' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'apps-invoice-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-add',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/invoice/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'apps-invoice-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-edit-id',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/invoice/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            /* internal name: 'apps-invoice-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-list',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/invoice/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'preview',
            /* internal name: 'apps-invoice-preview' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-preview-id',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/invoice/preview/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'kanban',
        /* internal name: 'apps-kanban' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-kanban',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/kanban/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'logistics',
        /* internal name: 'apps-logistics' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-logistics-dashboard',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/logistics/dashboard.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'fleet',
            name: 'apps-logistics-fleet',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/logistics/fleet.vue'),
            /* no children */
          },
  _definePage_default_4
  )
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/permissions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/user/view/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'v2',
        /* internal name: 'apps-v2' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/index.vue'),
            /* no children */
          },
          {
            path: 'analytics',
            name: 'apps-v2-analytics',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/analytics.vue'),
            /* no children */
          },
          {
            path: 'audit-log',
            name: 'apps-v2-audit-log',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/audit-log.vue'),
            /* no children */
          },
          {
            path: 'batch-explorer',
            name: 'apps-v2-batch-explorer',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/batch-explorer.vue'),
            /* no children */
          },
          {
            path: 'brand-management',
            name: 'apps-v2-brand-management',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/brand-management.vue'),
            /* no children */
          },
          {
            path: 'category-management',
            name: 'apps-v2-category-management',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/category-management.vue'),
            /* no children */
          },
          {
            path: 'current-hour-plan',
            name: 'apps-v2-current-hour-plan',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/current-hour-plan.vue'),
            /* no children */
          },
          {
            path: 'dcgwaste',
            name: 'apps-v2-dcgwaste',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/dcgwaste.vue'),
            /* no children */
          },
          {
            path: 'equipment',
            name: 'apps-v2-equipment',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/equipment.vue'),
            /* no children */
          },
          {
            path: 'hold-alerts',
            name: 'apps-v2-hold-alerts',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/hold-alerts.vue'),
            /* no children */
          },
          {
            path: 'hold-reconciliation',
            name: 'apps-v2-hold-reconciliation',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/hold-reconciliation.vue'),
            /* no children */
          },
          {
            path: 'login',
            name: 'apps-v2-login',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/login.vue'),
            /* no children */
          },
          {
            path: 'manager-overrides',
            name: 'apps-v2-manager-overrides',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/manager-overrides.vue'),
            /* no children */
          },
          {
            path: 'manual-make',
            name: 'apps-v2-manual-make',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/manual-make.vue'),
            /* no children */
          },
          {
            path: 'my-profile',
            name: 'apps-v2-my-profile',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/my-profile.vue'),
            /* no children */
          },
          {
            path: 'prep-zone-management',
            name: 'apps-v2-prep-zone-management',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/prep-zone-management.vue'),
            /* no children */
          },
          {
            path: 'product-management',
            name: 'apps-v2-product-management',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/product-management.vue'),
            /* no children */
          },
          {
            path: 'reports',
            /* internal name: 'apps-v2-reports' */
            /* no component */
            children: [
              {
                path: 'compliance',
                name: 'apps-v2-reports-compliance',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/reports/compliance.vue'),
                /* no children */
              },
              {
                path: 'production',
                name: 'apps-v2-reports-production',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/reports/production.vue'),
                /* no children */
              },
              {
                path: 'sell-through',
                name: 'apps-v2-reports-sell-through',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/reports/sell-through.vue'),
                /* no children */
              },
              {
                path: 'waste',
                name: 'apps-v2-reports-waste',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/reports/waste.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'settings',
            name: 'apps-v2-settings',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/settings.vue'),
            /* no children */
          },
          {
            path: 'staff-management',
            name: 'apps-v2-staff-management',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/staff-management.vue'),
            /* no children */
          },
          {
            path: 'station-view',
            name: 'apps-v2-station-view',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/station-view.vue'),
            /* no children */
          },
          {
            path: 'waste-entry',
            name: 'apps-v2-waste-entry',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/waste-entry.vue'),
            /* no children */
          },
          {
            path: 'workflow-history',
            name: 'apps-v2-workflow-history',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/apps/v2/workflow-history.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/charts',
    /* internal name: 'charts' */
    /* no component */
    children: [
      {
        path: 'apex-chart',
        name: 'charts-apex-chart',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/charts/apex-chart.vue'),
        /* no children */
      },
      {
        path: 'chartjs',
        name: 'charts-chartjs',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/charts/chartjs.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/components',
    /* internal name: 'components' */
    /* no component */
    children: [
      {
        path: 'alert',
        name: 'components-alert',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/alert.vue'),
        /* no children */
      },
      {
        path: 'avatar',
        name: 'components-avatar',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/avatar.vue'),
        /* no children */
      },
      {
        path: 'badge',
        name: 'components-badge',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/badge.vue'),
        /* no children */
      },
      {
        path: 'button',
        name: 'components-button',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/button.vue'),
        /* no children */
      },
      {
        path: 'chip',
        name: 'components-chip',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/chip.vue'),
        /* no children */
      },
      {
        path: 'dialog',
        name: 'components-dialog',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/dialog.vue'),
        /* no children */
      },
      {
        path: 'expansion-panel',
        name: 'components-expansion-panel',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/expansion-panel.vue'),
        /* no children */
      },
      {
        path: 'list',
        name: 'components-list',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/list.vue'),
        /* no children */
      },
      {
        path: 'menu',
        name: 'components-menu',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/menu.vue'),
        /* no children */
      },
      {
        path: 'pagination',
        name: 'components-pagination',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/pagination.vue'),
        /* no children */
      },
      {
        path: 'progress-circular',
        name: 'components-progress-circular',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/progress-circular.vue'),
        /* no children */
      },
      {
        path: 'progress-linear',
        name: 'components-progress-linear',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/progress-linear.vue'),
        /* no children */
      },
      {
        path: 'snackbar',
        name: 'components-snackbar',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/snackbar.vue'),
        /* no children */
      },
      {
        path: 'tabs',
        name: 'components-tabs',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/tabs.vue'),
        /* no children */
      },
      {
        path: 'timeline',
        name: 'components-timeline',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/timeline.vue'),
        /* no children */
      },
      {
        path: 'tooltip',
        name: 'components-tooltip',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/components/tooltip.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/control-center',
    /* internal name: 'control-center' */
    /* no component */
    children: [
      {
        path: 'roles-permissions',
        name: 'control-center-roles-permissions',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/control-center/roles-permissions.vue'),
        /* no children */
      },
      {
        path: 'store-details',
        name: 'control-center-store-details',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/control-center/store-details.vue'),
        /* no children */
      },
      {
        path: 'user-management',
        name: 'control-center-user-management',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/control-center/user-management.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/dashboards/analytics.vue'),
        /* no children */
      },
      {
        path: 'crm',
        name: 'dashboards-crm',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/dashboards/crm.vue'),
        /* no children */
      },
      {
        path: 'ecommerce',
        name: 'dashboards-ecommerce',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/dashboards/ecommerce.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/extensions',
    /* internal name: 'extensions' */
    /* no component */
    children: [
      {
        path: 'swiper',
        name: 'extensions-swiper',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/extensions/swiper.vue'),
        /* no children */
      },
      {
        path: 'tour',
        name: 'extensions-tour',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/extensions/tour.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/forms',
    /* internal name: 'forms' */
    /* no component */
    children: [
      {
        path: 'autocomplete',
        name: 'forms-autocomplete',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/autocomplete.vue'),
        /* no children */
      },
      {
        path: 'checkbox',
        name: 'forms-checkbox',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/checkbox.vue'),
        /* no children */
      },
      {
        path: 'combobox',
        name: 'forms-combobox',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/combobox.vue'),
        /* no children */
      },
      {
        path: 'custom-input',
        name: 'forms-custom-input',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/custom-input.vue'),
        /* no children */
      },
      {
        path: 'date-time-picker',
        name: 'forms-date-time-picker',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/date-time-picker.vue'),
        /* no children */
      },
      {
        path: 'editors',
        name: 'forms-editors',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/editors.vue'),
        /* no children */
      },
      {
        path: 'file-input',
        name: 'forms-file-input',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/file-input.vue'),
        /* no children */
      },
      {
        path: 'form-layouts',
        name: 'forms-form-layouts',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/form-layouts.vue'),
        /* no children */
      },
      {
        path: 'form-validation',
        name: 'forms-form-validation',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/form-validation.vue'),
        /* no children */
      },
      {
        path: 'form-wizard-icons',
        name: 'forms-form-wizard-icons',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/form-wizard-icons.vue'),
        /* no children */
      },
      {
        path: 'form-wizard-numbered',
        name: 'forms-form-wizard-numbered',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/form-wizard-numbered.vue'),
        /* no children */
      },
      {
        path: 'radio',
        name: 'forms-radio',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/radio.vue'),
        /* no children */
      },
      {
        path: 'range-slider',
        name: 'forms-range-slider',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/range-slider.vue'),
        /* no children */
      },
      {
        path: 'rating',
        name: 'forms-rating',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/rating.vue'),
        /* no children */
      },
      {
        path: 'select',
        name: 'forms-select',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/select.vue'),
        /* no children */
      },
      {
        path: 'slider',
        name: 'forms-slider',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/slider.vue'),
        /* no children */
      },
      {
        path: 'switch',
        name: 'forms-switch',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/switch.vue'),
        /* no children */
      },
      {
        path: 'textarea',
        name: 'forms-textarea',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/textarea.vue'),
        /* no children */
      },
      {
        path: 'textfield',
        name: 'forms-textfield',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/forms/textfield.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/front-pages',
    /* internal name: 'front-pages' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'checkout',
        name: 'front-pages-checkout',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/checkout.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
      {
        path: 'help-center',
        /* internal name: 'front-pages-help-center' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-help-center',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/help-center/index.vue'),
            /* no children */
          },
  _definePage_default_6
  ),
          {
            path: 'article',
            /* internal name: 'front-pages-help-center-article' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':title',
                name: 'front-pages-help-center-article-title',
                component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/help-center/article/[title].vue'),
                /* no children */
              },
  _definePage_default_7
  )
            ],
          }
        ],
      },
      {
        path: 'landing-page',
        /* internal name: 'front-pages-landing-page' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-landing-page',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/landing-page/index.vue'),
            /* no children */
          },
  _definePage_default_8
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'payment',
        name: 'front-pages-payment',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/payment.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'pricing',
        name: 'front-pages-pricing',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/front-pages/pricing.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/insights-overview',
    /* internal name: 'insights-overview' */
    /* no component */
    children: [
      {
        path: 'ai',
        /* internal name: 'insights-overview-ai' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'insights-overview-ai',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/insights-overview/ai/index.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_12
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_13
  ),
  {
    path: '/NotFound',
    name: 'not-found',
    component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/NotFound.vue'),
    /* no children */
  },
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'account-settings',
        /* internal name: 'pages-account-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-account-settings-tab',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/account-settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'pages-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password-v1',
            name: 'pages-authentication-forgot-password-v1',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/forgot-password-v1.vue'),
            /* no children */
          },
  _definePage_default_15
  ),
  _mergeRouteRecord(
          {
            path: 'forgot-password-v2',
            name: 'pages-authentication-forgot-password-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/forgot-password-v2.vue'),
            /* no children */
          },
  _definePage_default_16
  ),
  _mergeRouteRecord(
          {
            path: 'login-v1',
            name: 'pages-authentication-login-v1',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/login-v1.vue'),
            /* no children */
          },
  _definePage_default_17
  ),
  _mergeRouteRecord(
          {
            path: 'login-v2',
            name: 'pages-authentication-login-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/login-v2.vue'),
            /* no children */
          },
  _definePage_default_18
  ),
  _mergeRouteRecord(
          {
            path: 'register-multi-steps',
            name: 'pages-authentication-register-multi-steps',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/register-multi-steps.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
  _mergeRouteRecord(
          {
            path: 'register-v1',
            name: 'pages-authentication-register-v1',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/register-v1.vue'),
            /* no children */
          },
  _definePage_default_20
  ),
  _mergeRouteRecord(
          {
            path: 'register-v2',
            name: 'pages-authentication-register-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/register-v2.vue'),
            /* no children */
          },
  _definePage_default_21
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v1',
            name: 'pages-authentication-reset-password-v1',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/reset-password-v1.vue'),
            /* no children */
          },
  _definePage_default_22
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v2',
            name: 'pages-authentication-reset-password-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/reset-password-v2.vue'),
            /* no children */
          },
  _definePage_default_23
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v1',
            name: 'pages-authentication-two-steps-v1',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/two-steps-v1.vue'),
            /* no children */
          },
  _definePage_default_24
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v2',
            name: 'pages-authentication-two-steps-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/two-steps-v2.vue'),
            /* no children */
          },
  _definePage_default_25
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v1',
            name: 'pages-authentication-verify-email-v1',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/verify-email-v1.vue'),
            /* no children */
          },
  _definePage_default_26
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v2',
            name: 'pages-authentication-verify-email-v2',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/authentication/verify-email-v2.vue'),
            /* no children */
          },
  _definePage_default_27
  )
        ],
      },
      {
        path: 'cards',
        /* internal name: 'pages-cards' */
        /* no component */
        children: [
          {
            path: 'card-actions',
            name: 'pages-cards-card-actions',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/cards/card-actions.vue'),
            /* no children */
          },
          {
            path: 'card-advance',
            name: 'pages-cards-card-advance',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/cards/card-advance.vue'),
            /* no children */
          },
          {
            path: 'card-basic',
            name: 'pages-cards-card-basic',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/cards/card-basic.vue'),
            /* no children */
          },
          {
            path: 'card-statistics',
            name: 'pages-cards-card-statistics',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/cards/card-statistics.vue'),
            /* no children */
          },
          {
            path: 'card-widgets',
            name: 'pages-cards-card-widgets',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/cards/card-widgets.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dialog-examples',
        /* internal name: 'pages-dialog-examples' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-dialog-examples',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/dialog-examples/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'faq',
        name: 'pages-faq',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/faq.vue'),
        /* no children */
      },
      {
        path: 'icons',
        name: 'pages-icons',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/icons.vue'),
        /* no children */
      },
      {
        path: 'misc',
        /* internal name: 'pages-misc' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'coming-soon',
            name: 'pages-misc-coming-soon',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/misc/coming-soon.vue'),
            /* no children */
          },
  _definePage_default_28
  ),
  _mergeRouteRecord(
          {
            path: 'under-maintenance',
            name: 'pages-misc-under-maintenance',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/misc/under-maintenance.vue'),
            /* no children */
          },
  _definePage_default_29
  )
        ],
      },
      {
        path: 'pricing',
        name: 'pages-pricing',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/pricing.vue'),
        /* no children */
      },
      {
        path: 'typography',
        name: 'pages-typography',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/typography.vue'),
        /* no children */
      },
      {
        path: 'user-profile',
        /* internal name: 'pages-user-profile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-user-profile-tab',
            component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/pages/user-profile/[tab].vue'),
            /* no children */
          },
  _definePage_default_30
  )
        ],
      }
    ],
  },
  {
    path: '/tables',
    /* internal name: 'tables' */
    /* no component */
    children: [
      {
        path: 'data-table',
        name: 'tables-data-table',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/tables/data-table.vue'),
        /* no children */
      },
      {
        path: 'simple-table',
        name: 'tables-simple-table',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/tables/simple-table.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/wizard-examples',
    /* internal name: 'wizard-examples' */
    /* no component */
    children: [
      {
        path: 'checkout',
        name: 'wizard-examples-checkout',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/wizard-examples/checkout.vue'),
        /* no children */
      },
      {
        path: 'create-deal',
        name: 'wizard-examples-create-deal',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/wizard-examples/create-deal.vue'),
        /* no children */
      },
      {
        path: 'property-listing',
        name: 'wizard-examples-property-listing',
        component: () => import('/home/runner/work/InsightsLite/InsightsLite/resources/js/pages/wizard-examples/property-listing.vue'),
        /* no children */
      }
    ],
  }
]
